import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'

export interface Props {
	as?: "button" | "a"
	children?: any
	className?: string
	size?: "sm" | "md" | "lg"
	type?: "primary" | "secondary" | "secondary-alt" | "tertiary"
	onClick?: () => void
	href?: string
	hideArrow?: boolean,
	fitContent?: boolean
	target?: string
}

export const Button = ({as = "button", href, children, hideArrow, type = "primary", size = "md", className, onClick, fitContent, target = ''}: Props) => {

	let ButtonAs = as

	if (as == "a" || target || href) {
		ButtonAs = 'a'
	} else {
		ButtonAs = 'button'
	}


	return (
		<ButtonAs onClick={onClick} href={href} target={target} rel={target == '_blank' ? 'noopener noreferrer' : ''} className={['flex group items-center justify-center space-x-3 rounded border-2 font-bold uppercase font-museo',
		type == "primary" ? "bg-action-primary-yellow-100 border-action-primary-yellow-100 text-action-primary-blue-120 font-bold" : "",
		type == "secondary" ? "bg-action-primary-blue-100 border-action-primary-blue-100 text-white" : "",
		type == "secondary-alt" ? "bg-action-primary-blue-100 border-action-primary-blue-100 text-white border-2 border-white" : "",
		type == "tertiary" ? "bg-transparent border-action-primary-blue-100 text-action-primary-blue-100" : "",
		size == "sm" ? "text-sm px-6 py-2.5" : "",
		size == "md" ? "text-md px-6 py-3" : "",
		size == "lg" ? "text-[18px] text leading-7 py-3 px-6" : "",
		fitContent ? 'w-fit' : "",
		className].join(" ")}>
			{ children }
			{!hideArrow &&
				<div className='group-hover:ml-[15px] flex items-center group-hover:opacity-100 -ml-2.5 duration-300 opacity-0 w-2.5'>
					<FontAwesomeIcon
						icon={faChevronRight}
						className={'w-[16px] h-[16px]'}
					/>
				</div>
			}
		</ButtonAs>
	)
}
